//react
import React from "react";
//UI components
import Loader from "react-loader-spinner";
import "./Modal1.scss";

export const Modal1 = ({ handleClose, show, parent, children }) => {
  const showHideClassName = show
    ? "modal1 display-block"
    : "modal1 display-none";
  return (
    <div className={showHideClassName}>
      <Loader
        type="TailSpin"
        color="#918d8d"
        height={80}
        width={80}
        visible={true}
        className="loader"
      />
    </div>
  );
};

